import FilterProperties from './filter-properties';

export default FilterProperties;
